import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import { fetchWork } from '../requests/work_request';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import NotFound from '../containers/NotFound';
import SliderWork from '../components/Pages/Work/SliderWork';
import RenderIntroWork from '../components/Pages/Work/RenderIntroWork';
import RenderSingleWork from '../components/Pages/Work/RenderSingleWork';
import CallToWork from '../components/Pages/Work/CallToWork';
import WorkHeader from '../components/Pages/Work/WorkHeader';
import NextPost from './NextPost';
import Share from '../components/Pages/Share';

import OnVisible, { setDefaultProps } from 'react-on-visible';

setDefaultProps({
    bounce: true,
});

class SingleWork extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextProps.work.posts[0]) {
            const currentIndex = _.findIndex(nextProps.work.posts, [
                'slug',
                this.props.match.params.slug,
            ]);

            if (nextProps.work.posts[currentIndex]) {
                document.title = `${nextProps.work.posts[currentIndex].title.rendered} - Friends for Brands`;
            } else {
                document.title = '404 - Project not found';
            }
        }
    }

    getPosts(props, willMount = false) {
        if (willMount) {
            this.props.fetchWork('work');
        }
    }

    Work404() {
        return (
            <div className="single single-404">
                <Header />
                <main id="main-404">
                    <div id="main-container">
                        <div className="content-container">
                            <Loader
                                loaded={
                                    this.props.work.fetched ||
                                    this.props.work.failed
                                }
                            />
                            {this.props.work.fetched && (
                                <div className="fadeIn">
                                    <NotFound />
                                </div>
                            )}
                        </div>
                    </div>
                </main>
            </div>
        );
    }

    getTag() {
        if (this.props.work.posts[0]) {
            const currentIndex = _.findIndex(this.props.work.posts, [
                'slug',
                this.props.match.params.slug,
            ]);

            return this.props.work.posts[currentIndex].tags[0];
        } else {
            return false;
        }
    }

    getTagName() {
        //Remove dashes from slug
        let slug = this.props.match.params.slug;

        slug = slug.replace(/-/g, '');
        return slug;
    }

    curPost() {
        if (this.props.work.posts[0]) {
            const currentIndex = _.findIndex(this.props.work.posts, [
                'slug',
                this.props.match.params.slug,
            ]);
            return currentIndex;
        } else {
            return 0;
        }
    }

    render() {
        const ACF_FIELD =
            !!this.props.work.posts[this.curPost()] &&
            this.props.work.posts[this.curPost()].acf;

        let hasSlug;
        if (this.props.work.fetched) {
            hasSlug = _.findIndex(this.props.work.posts, [
                'slug',
                this.props.match.params.slug,
            ]);
        }

        return this.props.work.fetched &&
            this.props.work.posts[this.curPost()] ? (
            <div
                className={`work single ${
                    this.props.work.fetched &&
                    this.props.work.posts[this.curPost()].acf
                        .work_fontcolor_selection !== 'zwart'
                        ? 'white'
                        : 'black'
                }`}>
                <Header
                    isWork={true}
                    slider={this.props.work.posts[this.curPost()]}
                />
                <main>
                    {this.props.work.fetched && hasSlug !== -1 && (
                        <div className="fadeIn">
                            <WorkHeader
                                slider={this.props.work.posts[this.curPost()]}
                            />
                        </div>
                    )}
                    {this.props.work.fetched && (
                        <div className="fadeIn">
                            <div
                                className={`work__intro-block`}
                                style={{
                                    backgroundColor: this.props.work.posts[
                                        this.curPost()
                                    ].acf.work_colorpicker_bg,
                                }}>
                                <div className="clearfix" />
                                {this.props.work.posts[this.curPost()].acf
                                    .slider && (
                                    <div className="content-container">
                                        <Share
                                            className="share-withcover"
                                            title={
                                                this.props.work.posts[
                                                    this.curPost()
                                                ].title.rendered || ''
                                            }
                                        />
                                        <div className="clearfix" />
                                        {this.props.work.posts[this.curPost()]
                                            .acf && (
                                            <RenderIntroWork
                                                fields={
                                                    this.props.work.posts[
                                                        this.curPost()
                                                    ].acf
                                                }
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                    <div id="main-container">
                        <div className="content-container">
                            <Link
                                to={{
                                    pathname: '/behind-the-scenes',
                                    state: { transition: 'slideLeft' },
                                }}
                                className="nav-btn">
                                <i className="icon icon-arrow_right" />
                                <span>Behind the scenes</span>
                            </Link>
                            <Loader
                                loaded={
                                    this.props.work.fetched ||
                                    this.props.work.failed
                                }
                            />
                            {this.props.work.fetched && (
                                <div className="fadeIn">
                                    {hasSlug !== -1 ? (
                                        <div>
                                            <RenderSingleWork
                                                posts={this.props.work}
                                                index={this.curPost()}
                                                name={this.props.name}
                                            />
                                        </div>
                                    ) : (
                                        <h2>
                                            :(!
                                            <br />
                                            Er is iets misgegaan. Probeer het
                                            later opnieuw.
                                            <br />
                                            <br />
                                        </h2>
                                    )}
                                </div>
                            )}
                            {this.props.work.failed && (
                                <h2>
                                    :(!
                                    <br />
                                    Er is iets misgegaan. Probeer het later
                                    opnieuw.
                                    <br />
                                    <br />
                                </h2>
                            )}
                        </div>

                        <div className="null-margin">
                            <OnVisible className="not-appeared">
                                {this.props.work.fetched && (
                                    <SliderWork
                                        slides={ACF_FIELD.work_slides}
                                        bgColor={ACF_FIELD.work_slides_bgcolor}
                                        arrowsColorBG={
                                            ACF_FIELD.work_slides_arrows
                                        }
                                        arrowsColorHoverBG={
                                            ACF_FIELD.work_slides_arrows_hover
                                        }
                                        arrowsColor={
                                            ACF_FIELD.work_slides_arrows_color
                                        }
                                        arrowsColorHover={
                                            ACF_FIELD.work_slides_arrows_color_hover
                                        }
                                        dotsColor={ACF_FIELD.work_slides_dots}
                                        titleColor={
                                            ACF_FIELD.work_slides_title_color
                                        }
                                    />
                                )}
                                {this.props.work.fetched &&
                                    this.props.work.posts[this.curPost()].acf
                                        .banner_enabled && (
                                        <React.Fragment>
                                            <CallToWork
                                                name={
                                                    ACF_FIELD.banner_friendimg
                                                        .display_name
                                                }
                                                title={ACF_FIELD.banner_title}
                                                text={
                                                    ACF_FIELD.banner_friendimg
                                                        .nickname
                                                }
                                                phone={ACF_FIELD.banner_phone}
                                                email={
                                                    ACF_FIELD.banner_friendimg
                                                        .user_email
                                                }
                                                avatar={
                                                    ACF_FIELD.banner_friendimg
                                                }
                                            />
                                        </React.Fragment>
                                    )}
                            </OnVisible>
                        </div>
                    </div>
                    {this.props.work.fetched && hasSlug !== -1 && (
                        <div className="work__footercontainer">
                            <NextPost
                                next="next"
                                nextposts={this.props.work.posts}
                                slug={this.props.match.params.slug}
                            />
                            <Footer name={this.props.name} type="work" />
                        </div>
                    )}
                </main>
            </div>
        ) : (
            this.Work404()
        );
    }
}

function mapStateToProps({ work }) {
    return { work };
}

export default withRouter(connect(mapStateToProps, { fetchWork })(SingleWork));



// WEBPACK FOOTER //
// ./src/containers/SingleWork.jsx